import { React, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import FetchModule from '../../Share/Network/FetchModule';

import { useLanguage } from '../../../Context/LanguageContext';

const NotReceivedInfo = (props) => {
  const { data, selectedPartnerGym } = props;

  const history = useHistory();
  const { t } = useLanguage();

  const TextRef = useRef();

  function onMouseOver() {
    TextRef.current.style.color = `#FF8B48`;
  }

  function onMouseLeave() {
    TextRef.current.style.color = `#CBCBCB`;
  }

  function onClickNotReceive(e) {
    // if (e.target !== TextRef.current) {
    //   if (selectedPartnerGym === undefined || selectedPartnerGym.isMyStore) history.push('/member/valid/detail/' + data.memberId);
    //   else history.push('/member/partner_gym/detail/' + data.memberId);
    // }

    const element = TextRef.current;

    if (!element || element.contains(e.target)) return;

    if (selectedPartnerGym === undefined || selectedPartnerGym.isMyStore) history.push('/member/valid/detail/' + data.memberId);
    else history.push('/member/partner_gym/detail/' + data.memberId);
  }

  function onClickPushNotification() {
    if (selectedPartnerGym === undefined || selectedPartnerGym.isMyStore) {
      let requestData = {
        userId: data.userId,
        itemName: data.itemName,
        price: data.notReceivedPrice
      }

      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataOfCoachVersion2('push_notification/sales/not-received', 'POST', requestData);

          if (responseData.status === 200) {
            alert(t('statistics.notReceived.pushSent'));
          }
          else if (responseData.status === 204) {
            alert(t('statistics.notReceived.memberWithdrawn'));
          }
        }
      )();
    }
  }


  // 결제 금액 정리 //
  function decideTotalPriceView(data) {
    if (data.selectedPaymentOptions === undefined || data.selectedPaymentOptions.length === 0) {
      if (data.cardPrice === 0 && data.cashPrice === 0) return t('statistics.sales.free');
      else if (data.cardPrice === 0) return data.cashPrice.toLocaleString('ko-KR') + t('statistics.sales.paymentCash');
      else if (data.cashPrice === 0) return data.cardPrice.toLocaleString('ko-KR') + t('statistics.sales.paymentCard');
      else return (parseInt(data.cashPrice) + parseInt(data.cardPrice)).toLocaleString('ko-KR') + t('statistics.sales.paymentMixed');
    } 
    else {
      const allSame = data.selectedPaymentOptions.every(item => item.paymentOptionName === data.selectedPaymentOptions[0].paymentOptionName);
      const totalPrice = data.selectedPaymentOptions.reduce((sum, item) => sum + item.price, 0);

      if (allSame) return totalPrice.toLocaleString('ko-KR') + ' - ' + data.selectedPaymentOptions[0].paymentOptionName;
      else return totalPrice.toLocaleString('ko-KR') + t('statistics.sales.paymentMixed');
    }
  }

  return (
    <TopLevelWrapper>
      <Table>
        <Body>
          <BodyTr /*onMouseOver={onMouseOver} onMouseLeave={onMouseLeave} */onClick={onClickNotReceive}>
            <Td style={{
              minWidth: `85px`,
              width: `85px`,
              marginRight: `5px`/*width: `60px`, marginLeft: '19px'*/,
              padding: `0px`,
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis'
            }}>
              {data.name}
            </Td>
            {/* <Td style={{ width: `66px`, marginLeft: '7px' }}>
              {data.division}
            </Td> */}
            <Td style={{
              width: `170px`,
              marginRight: `5px`,
              padding: `0px`,
              overflow: `hidden`,
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis'  /*width: `276px`*/
            }}>
              {data.itemName}
            </Td>
            <Td style={{ width: `283px` }}>
              {decideTotalPriceView(data)}
            </Td>
            <Td style={{ width: `105px` }}>
              {data.discountPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            </Td>
            <Td style={{ width: `100px` }}>
              {data.notReceivedPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            </Td>
            <Td style={{ width: `105px` }}>
              {data.approvalDate.split('T')[0][2]
                + data.approvalDate.split('T')[0][3]
                + '.'
                + data.approvalDate.split('T')[0][5]
                + data.approvalDate.split('T')[0][6]
                + '.'
                + data.approvalDate.split('T')[0][8]
                + data.approvalDate.split('T')[0][9]}
            </Td>
            <Td style={{ width: `74px` }}>
              <PushMessageButton 
                ref={TextRef}
                style={(selectedPartnerGym === undefined || selectedPartnerGym.isMyStore) ? { opacity: '1' } : { opacity: '0' }}
                onClick={onClickPushNotification} >
                <CustomText style={{ marginTop: '-2px'}} fontFmaily='NotoSansKR-Regular' fontSize={10} color='#FFFFFF' cursor='pointer'>{t('statistics.notReceived.sendMessage')}</CustomText>
              </PushMessageButton>
            </Td>
          </BodyTr>
        </Body>
      </Table>
    </TopLevelWrapper>
  )
}

export default NotReceivedInfo;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  width: 100%;
`;

const Table = styled.table`
  display: flex;
  flex-direction: column;
  
  width: 100%;

`;

const Body = styled.tbody`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  // width: 992px;
  width: 100%;
`;

const BodyTr = styled.tr`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 100%;

  background-color: #FFFFFF;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    background-color: #FFE0CD;
  }
`;

const Td = styled.td`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  height: 36px;

  color: #595959;
`;

const PushMessageButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 45px;
  height: 16px;

  border-radius: 2px;
  background-color: #ECECEC;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    background-color: #FF8B48;
  }
`;

const Text = styled.span`
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: #CBCBCB;

  margin: 0 0 0 0;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;


const CustomText = styled.div`
  font-family: ${props => props.fontFmaily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }

  transition: all 0.3s ease-in-out;
`;